import React from 'react'
import { useTranslations } from '@dustin-web/microsite-components/src/hooks'
import classNames from 'classnames'
import { getProductUrl } from '@dustin-web/microsite-components/src/utils/urls'

type Props = {
  productErpIdentifier: string
  nameSlug: string
}

const GoToProductButton = ({ productErpIdentifier, nameSlug }: Props) => {
  const { translate } = useTranslations()
  return (
    <div className="c-product-card__add-to-cart-wrapper">
      <a
        href={getProductUrl(productErpIdentifier, nameSlug)}
        className={classNames(
          'c-btn c-btn--block c-btn--primary u-mb-0 c-product-card__add-to-cart'
        )}>
        {translate('GoToProduct')}
      </a>
    </div>
  )
}
export default GoToProductButton
